<div>
    <div *ngIf="body" style="white-space: pre-line">{{body}}</div>
</div>